import { IconButton } from "@similarweb/ui-components";
import { ItemIcon } from "@similarweb/ui-components";
import { Type } from "pro-features/pages/app performance/src/page/StyledComponents";
import { StyledDomainContainer, StyledWebSite, StyledWebSiteLink } from "./styles";
import { PlainTooltip } from "@similarweb/ui-components";
import { i18nFilter } from "app/filters/i18nFilter";
import type { WebsiteType } from "app/components/QualificationSideBar/types";
import { allTrackers } from "app/services/track/track";

type WebsiteProps = {
    website: WebsiteType;
};

const WebsiteWithLink = (props: WebsiteProps) => {
    const { domain, favicon } = props.website;
    const i18n = i18nFilter();
    return (
        <StyledWebSite>
            <ItemIcon
                iconType={Type.Website}
                iconSrc={favicon}
            />
            <StyledDomainContainer>
                <span>{domain}</span>
            </StyledDomainContainer>
            <PlainTooltip
                placement="bottom"
                tooltipContent={i18n("qualification.sidebar.header.link.website.tooltip")}
            >
                <StyledWebSiteLink
                    target="_blank"
                    href={`http://${domain}`}
                    data-automation="website-header-link-out"
                >
                    <IconButton
                        type="flat"
                        iconName="link-out"
                        iconSize="xs"
                        onClick={() => {
                            allTrackers.dispatchTrackEvent(
                                "External Link",
                                "click",
                                `QualificationSidebarHeader/external/${domain || ""}`,
                            );
                        }}
                    />
                </StyledWebSiteLink>
            </PlainTooltip>
        </StyledWebSite>
    );
};

export default WebsiteWithLink;
